/**
 * @generated SignedSource<<7b435800dd06503be2f6efbe5f6ac42b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience$data = {
  readonly key: string;
  readonly projectId: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"formatRules_businessConditionalFormattingSidebar_FormatRulesFragment">;
  readonly " $fragmentType": "conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience";
};
export type conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience$key = {
  readonly " $data"?: conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience$data;
  readonly " $fragmentSpreads": FragmentRefs<"conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        }
      ],
      "kind": "FragmentSpread",
      "name": "formatRules_businessConditionalFormattingSidebar_FormatRulesFragment"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "0e1bf290587cfae39877279b4f00241a";

export default node;
